import React from "react";
import scrubImg from "./body-scrub.jpg";   // ⭐ Correct image path

const BodyScrub = ({ setActiveSection }) => {
  return (
    <section className="bg-white text-gray-900">

      {/* ⭐  STYLE FULL-WIDTH BANNER */}
      <div className="relative w-full h-[350px] md:h-[450px]">
        <img
          src={scrubImg}
          alt="Body Scrub Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50 backdrop-blur-[1px]"></div>

        {/* Center Title */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg tracking-wide">
            Body Scrub
          </h1>
        </div>

        {/* Bottom Left Title */}
        <div className="absolute bottom-0 left-0 bg-black/40 backdrop-blur-md w-full py-4 px-6">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            Body Scrub
          </h2>
        </div>

        {/* Bottom Right Breadcrumb */}
        <div className="absolute bottom-0 right-0 bg-black/40 backdrop-blur-md py-4 px-6 flex gap-2 text-white">
          <button
            onClick={() => setActiveSection("home")}
            className="hover:text-amber-300"
          >
            Home
          </button>
          <span>›</span>
          <span className="text-amber-300">Body Scrub</span>
        </div>
      </div>

      {/* ⭐ MAIN CONTENT */}
      <div className="container mx-auto px-4 py-20">

        <div className="grid md:grid-cols-2 gap-14 items-center">

          {/* LEFT IMAGE */}
          <img
            src={scrubImg}
            alt="Body Scrub Treatment"
            className="rounded-2xl shadow-[0_10px_35px_rgba(0,0,0,0.3)] w-full h-[520px] object-cover border border-gray-200"
          />

          {/* RIGHT DETAILS */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-amber-900 leading-tight">
              Deep Exfoliation for Smooth, Glowing Skin
            </h2>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              Our Body Scrub gently exfoliates dead skin cells, unclogs pores,
              and boosts natural skin regeneration for smoother texture.
            </p>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              The scrub’s circular motion improves blood circulation, reduces
              dullness, and restores the skin’s natural radiance.
            </p>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              This treatment is ideal before any massage as it helps your skin
              absorb oils better, giving you a more relaxing spa experience.
            </p>

            <p className="text-gray-700 leading-relaxed mb-4 text-lg">
              Enjoy fresh, glowing, polished skin with our luxurious premium
              exfoliation therapy.
            </p>

            {/* Book Now */}
            <button
              onClick={() => setActiveSection("booking")}
              className="bg-amber-900 text-white px-12 py-4 rounded-lg text-lg 
                         hover:bg-amber-800 transition-all hover:scale-105 shadow-lg mt-6"
            >
              Book Now
            </button>
          </div>

        </div>

      </div>
    </section>
  );
};

export default BodyScrub;
